import { DatePipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { ShowArchiveService } from '../../services/show-archive.service';
import { ShowEvent } from '../../models/show-event.model';

type StatusFilter = 'Alle' | 'Gespielt' | 'Geplant' | 'Live';
type TimeFilter = 'Alle' | 'Vergangen' | 'Zukunft';

@Component({
  selector: 'app-show-archive',
  standalone: true,
  imports: [RouterLink, DatePipe, FormsModule],
  template: `
    <section class="section shows-page">
      <div class="page-title-block shows-title">
        <h1>SHOWS</h1>
        <span class="title-line"></span>
      </div>

      <div class="show-filters card accent-card">
        <label>
          <span>Format</span>
          <select [(ngModel)]="selectedFormat">
            <option>Alle</option>
            @for (format of formats; track format) {
              <option>{{ format }}</option>
            }
          </select>
        </label>

        <label>
          <span>Zeitraum</span>
          <select [(ngModel)]="selectedTime">
            <option>Alle</option>
            <option>Vergangen</option>
            <option>Zukunft</option>
          </select>
        </label>

        <label>
          <span>Status</span>
          <select [(ngModel)]="selectedStatus">
            <option>Alle</option>
            <option>Gespielt</option>
            <option>Geplant</option>
            <option>Live</option>
          </select>
        </label>
      </div>
    </section>

    <section class="section archive-list shows-list">
      @for (event of filteredEvents; track event.id) {
        <article class="show-event-card card accent-card">
          <div class="event-main">
            <p class="tag">{{ event.format }} · {{ event.status }}</p>
            <h2>{{ event.questionCount }} Fragen zu {{ event.title.replace(event.questionCount + ' Fragen zu ', '') }} | {{ event.date | date:'dd.MM.yyyy' }}</h2>
            <p>{{ event.summary }}</p>
          </div>
          <div class="event-meta">
            <span><strong>{{ event.questionCount }}</strong> Fragen</span>
            <span><strong>{{ event.participants.length }}</strong> Beteiligte</span>
            <span><strong>{{ event.winner }}</strong> Gewinner</span>
            <a class="button primary" [routerLink]="['/spielshows', event.id]">Detail ansehen</a>
          </div>
        </article>
      } @empty {
        <article class="card accent-card empty-state">
          <h2>Keine Shows gefunden</h2>
          <p>Für diese Filterkombination gibt es aktuell keinen Eintrag.</p>
        </article>
      }
    </section>
  `
})
export class ShowArchiveComponent {
  readonly archive = inject(ShowArchiveService);

  selectedFormat = 'Alle';
  selectedTime: TimeFilter = 'Alle';
  selectedStatus: StatusFilter = 'Alle';

  get formats(): string[] {
    return [...new Set(this.archive.events.map(event => event.format))];
  }

  get filteredEvents(): ShowEvent[] {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return this.archive.events.filter(event => {
      const eventDate = new Date(event.date);
      eventDate.setHours(0, 0, 0, 0);

      const matchesFormat = this.selectedFormat === 'Alle' || event.format === this.selectedFormat;
      const matchesStatus = this.selectedStatus === 'Alle' || event.status === this.selectedStatus;
      const matchesTime = this.selectedTime === 'Alle'
        || (this.selectedTime === 'Vergangen' && eventDate < today)
        || (this.selectedTime === 'Zukunft' && eventDate >= today);

      return matchesFormat && matchesStatus && matchesTime;
    });
  }
}
